module.exports = __webpack_public_path__ + "static/media/bg-mp4.16fa1ff.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/bg-mp4.mp4
// module id = 5dns
// module chunks = 14